import { AgentThreadMessage } from "@/store/chat.types";
import { AgentThreadMessageDetailType } from "../../api";

const TEMP_ID_PREFIX = "fe-temp-";

export function createOptimisticMessage(
  text: string,
  files: File[]
): AgentThreadMessage {
  const tempId = `${TEMP_ID_PREFIX}${Date.now()}`;
  return {
    id: tempId,
    type: AgentThreadMessageDetailType.User,
    content: {
      id: tempId,
      role_name: "user",
      role_type: "user",
      content: JSON.stringify({
        text: text.trim(),
        files: files.map((file) => {
          const url = URL.createObjectURL(file);
          return {
            file_path: url,
            mime_type: file.type,
          };
        }),
      }),
    },
    createTime: `${Date.now()}`,
    updateTime: `${Date.now()}`,
  };
}

export function omitOptimisticMessages(
  messages: AgentThreadMessage[]
): AgentThreadMessage[] {
  return messages.filter((m) => !m.id?.startsWith(TEMP_ID_PREFIX));
}
